export default "__VITE_ASSET__DW1u_l4p__"